module.exports = __webpack_public_path__ + "img/makin.74774394.png";